<template>
  <b-modal
    v-model="showModal"
    :title="`Send Email - ${record.po_number}`"
    @hidden="$emit('modal-closed')"
    @ok="submitHandler"
  >
    <b-card-text>
      <div>
        Are you sure you want to send email for <b>{{ record.po_number }}</b>?
        <br>
        <br>
      </div>
    </b-card-text>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :disabled="saving"
        @click="ok()"
      >
        Send
        <b-spinner
          v-if="saving"
          small
          label="Small Spinner"
        />
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BCardText, BButton, BSpinner,
} from 'bootstrap-vue'
import axios from 'axios'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
    BSpinner,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: true,
      saving: false,
    }
  },
  methods: {
    submitHandler(event) {
      event.preventDefault()
      this.saving = true

      const data = {
        po_id: this.record.id,
      }
      axios.post('/send_po_email', data)
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.saving = false
          this.showModal = false
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error?.response?.data?.error || 'Error sending email!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          this.saving = false
        })
    },
  },
}
</script>
